import React, { Component } from 'react';
import {
  Button, Checkbox, Form, Input, Select, Steps,
} from 'antd';
import { Link } from 'react-router-dom';
import { PREFIX_FRONT_URL } from '../consts';
import FloatLabelInputPasswordComponent from './common/FloatLabelInputPasswordComponent';
import FloatLabelInputComponent from './common/FloatLabelInputComponent';
import FloatLabelNumberComponent from './common/FloatLabelNumberComponent';

const { Step } = Steps;
const { Option } = Select;

class UserInfoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: false,
      currentStep: 0,
      params: {
        password: '',
        email: window._.get(props.user.info, 'email', ''),
        country: window._.get(props.user.info, 'country', ''),
        home_address: window._.get(props.user.info, 'home_address', ''),
        postal_code: window._.get(props.user.info, 'postal_code', ''),
        repeat_password: '',
      },
    };

    this.toggleNationality = this.toggleNationality.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.getStateStep = this.getStateStep.bind(this);
    this.updateUserInfo = this.updateUserInfo.bind(this);
  }

  updateUserInfo() {
    // todo validate here
    this.props.updateUserInfoAction(this.state.params);
  }

  toggleNationality() {
    this.setState({ params: { ...this.state.params, nationality: this.state.params.nationality } });
  }

  changeStep(currentStep) {
    this.setState({ currentStep });
  }

  getStateStep(step) {
    if (this.state.currentStep > step) {
      return 'finish';
    }

    if (this.state.currentStep === step) {
      return 'process';
    }

    if (this.state.currentStep < step) {
      return 'wait';
    }
  }

  render() {
    return (
      <div className="wrap-user-info-component">
        <div style={{
				  backgroundColor: 'white',
        }}
        >
          <Steps
            type="navigation"
            size="small"
            current={this.state.currentStep}
            onChange={(step) => this.changeStep(step)}
            className="site-navigation-steps"
          >
            <Step
							// title="Step 1"
							// subTitle="00:00:05"
              status={() => this.getStateStep(0)}
              description="Where are you from?"
            />
            {/* <Step */}
            {/*	title="Step 2" */}
            {/*	subTitle="00:01:02" */}
            {/*	status={() => this.getStateStep(1)} */}
            {/*	description="This is a description." */}
            {/* /> */}
            {/* <Step */}
            {/*	title="Step 3" */}
            {/*	subTitle="waiting for longlong time" */}
            {/*	status={() => this.getStateStep(2)} */}
            {/*	description="This is a description." */}
            {/* /> */}
          </Steps>
        </div>

        {/* <h4 className="text-center mb-medium mt-large text-white">Add user info</h4> */}
        {/* The first time add user info */}
        <div className="form-wrap">
          <Form
            layout="vertical"
            name="basic"
            size="large"
          >
            <Form.Item rules={[{ required: true, message: 'Email field is required' }]}>
              <FloatLabelInputComponent
                label="Email"
                value={this.state.params.email}
                onChange={({ target }) => {
								  this.setState({
								    params: {
								      ...this.state.params,
								      email: target.value,
								    },
								  });
                }}
                name="email"
              />
            </Form.Item>
            <Form.Item rules={[{ required: true, message: 'Country field is required' }]}>
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
                <Option value="tom">Tom</Option>
              </Select>
            </Form.Item>

            <Form.Item rules={[{ required: true, message: 'Home address field is required' }]} className="mt-medium">
              <FloatLabelInputComponent
                label="Home Address"
                value={this.state.params.homeAddress}
                onChange={({ target }) => {
								  this.setState({
								    params: {
								      ...this.state.params,
								      homeAddress: target.value,
								    },
								  });
                }}
                name="home_address"
              />
            </Form.Item>

            <Form.Item rules={[{ required: true, message: 'Postal code field is required' }]} className="mt-medium">
              <FloatLabelInputComponent
                label="Postal Code"
                value={this.state.params.postalCode}
                onChange={({ target }) => {
								  this.setState({
								    params: {
								      ...this.state.params,
								      postalCode: target.value,
								    },
								  });
                }}
                name="postal_code"
              />
            </Form.Item>

            <Form.Item rules={[{ required: true, message: 'Country field is required' }]}>
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={(country) => {
								  this.setState({
								    params: {
								      ...this.state.params,
								      country,
								    },
								  });
                }}
								// onFocus={onFocus}
								// onBlur={onBlur}
								// onSearch={onSearch}
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
                <Option value="tom">Tom</Option>
              </Select>
            </Form.Item>

            <Form.Item rules={[{ required: true, message: 'Password field is required' }]} className="mt-medium">
              <FloatLabelInputPasswordComponent
                label="Password"
                value={this.state.params.password}
                onChange={({ target }) => {
								  this.setState({
								    params: {
								      ...this.state.params,
								      password: target.value,
								    },
								  });
                }}
                name="password"
              />
            </Form.Item>

            <Form.Item rules={[{ required: true, message: 'Repeat Password field is required' }]} className="mt-medium">
              <FloatLabelInputPasswordComponent
                label="Repeat Password"
                value={this.state.params.repeatPassword}
                onChange={({ target }) => {
								  this.setState({
								    params: {
								      ...this.state.params,
								      repeatPassword: target.value,
								    },
								  });
                }}
                name="password"
              />
            </Form.Item>

            <Form.Item>
              <Checkbox onChange={() => this.toggleNationality()}> I hold nationality from this country</Checkbox>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" onClick={() => this.updateUserInfo()} className="btn-create">
                Update User Information
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

export default UserInfoComponent;
